import type { AppLocale } from "@/core/i18n/config";
import { getLocaleSwitcherOptions, localizeHref } from "@/core/i18n/routing";
import { HOME_PAGE_COPY } from "@/features/home/constants/home-page-copy";
import type { HomePageContent } from "@/features/home/types/home-page-content";

function localizeNavigation(locale: AppLocale) {
  const navigation = HOME_PAGE_COPY[locale].navigation;

  return {
    ...navigation,
    activeLocale: locale,
    homeHref: localizeHref(locale, "/"),
    localeOptions: getLocaleSwitcherOptions("/"),
    loginHref: localizeHref(locale, navigation.loginHref),
    items: navigation.items.map((item) => ({
      ...item,
      href: localizeHref(locale, item.href),
    })),
  };
}

function localizeFooter(locale: AppLocale) {
  const footer = HOME_PAGE_COPY[locale].footer;

  return {
    ...footer,
    ctaHref: localizeHref(locale, footer.ctaHref),
    legalLinks: footer.legalLinks.map((link) => ({
      ...link,
      href: localizeHref(locale, link.href),
    })),
    sections: footer.sections.map((section) => ({
      ...section,
      links: section.links.map((link) => ({
        ...link,
        href: localizeHref(locale, link.href),
      })),
    })),
  };
}

export async function getHomePageContent(locale: AppLocale): Promise<HomePageContent> {
  const content = HOME_PAGE_COPY[locale];

  return {
    ...content,
    ctaSection: {
      ...content.ctaSection,
      buttonHref: localizeHref(locale, content.ctaSection.buttonHref),
    },
    emotionalConnectionSection: {
      ...content.emotionalConnectionSection,
      ctaHref: localizeHref(locale, content.emotionalConnectionSection.ctaHref),
    },
    footer: localizeFooter(locale),
    hero: {
      ...content.hero,
      ctaHref: localizeHref(locale, content.hero.ctaHref),
    },
    navigation: localizeNavigation(locale),
    trustSection: {
      ...content.trustSection,
      ctaHref: localizeHref(locale, content.trustSection.ctaHref),
    },
    wellnessFeaturesSection: {
      ...content.wellnessFeaturesSection,
      features: content.wellnessFeaturesSection.features.map((feature) => ({
        ...feature,
        ctaHref: localizeHref(locale, feature.ctaHref),
      })),
    },
  };
}
